module.exports = __webpack_public_path__ + "img/sceneOpen.01564dc1.svg";